import React from "react";
import { InfoWindow } from "@react-google-maps/api";
import "./AlertWindow.scss";
import OpeningHoursNormal from "./OpeningHoursNormal";
import OpeningHoursEmergency from "./OpeningHoursEmergency";

const AlertWindow = ({
  selected,
  currentPosition,
  close,
  handleSendingData,
  handleTelefonInfoModal,
  formData
}) => {
  const handleDirections = () => {
    let currentPositionForLink = "";
    let selectedForLink = "";

    if (selected) {
      selectedForLink = selected.coordinates.latitude + "," + selected.coordinates.longitude;
    }
    if (currentPosition) {
      currentPositionForLink = currentPosition.lat + "," + currentPosition.lng;
    }

    if (typeof currentPosition.lat === "undefined") {
      currentPositionForLink = "";
    }
    let url = `https://google.com/maps/dir/${currentPositionForLink}/${selectedForLink}`;

    window.open(url);
  };

  return (
    <InfoWindow
      position={{ lat: selected.coordinates.latitude, lng: selected.coordinates.longitude }}
      onCloseClick={() => close()}
    >
      <div className="infowindow">
        <div className="infowindow__directions">
          <h2>{selected.name}</h2>
        </div>
        <div className="infowindow__cto">
          <div className="infowindow__directions--button" onClick={handleDirections}>
            Routenplanner
          </div>

          <div
            className="infowindow__directions--button"
            onClick={() => handleSendingData(selected)}
          >
            Digitale Voranmeldung
          </div>

          <a onClick={() => handleTelefonInfoModal(selected)}>
            <div className="infowindow__directions--button">Anrufen</div>
          </a>

        </div>

        <div className="infowindow__row">
          <h4>Adresse</h4>
          <span>{selected.address}</span>
        </div>
        <div className="infowindow__flexRow">
          <div className="infowindow__row">
            <h4>Telefon</h4>
            <a onClick={() => handleTelefonInfoModal(selected)}>{selected.tel}</a>
          </div>
          {selected.email && (
            <div className="infowindow__row">
              <h4>E-Mail</h4>
              <a href={`mailto:${selected.email}`} target="_blank" rel="nofollow">
                {selected.email}
              </a>
            </div>
          )}
        </div>
        <div className="infowindow__row">
          <h4>Webseite</h4>
          <a href={`${selected.website}`} target="_blank" rel="nofollow">
            {selected.website}
          </a>
        </div>
        {selected.openingHoursFields && (
          <div className="openingHours">
            <OpeningHoursNormal selected={selected} />
            <OpeningHoursEmergency selected={selected} />
          </div>
        )}
      </div>
    </InfoWindow>
  );
};

export default AlertWindow;
